export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8630.d0714d4e.jpg";